module.exports = __webpack_public_path__ + "h5/img/cygn1.1920373b.png";